export function transformGRNtoInvoiceFormat(originalData) {

    const grn = originalData.Data[0]; // Assuming only one GRN object
    const order = grn.GRNReferences?.[0]?.Order || {};
    const billingAddress = order.BillingAddress || {};


    // Set Print Detail As per Reference 

    let Party = "";
    let PartyName = "";
    let PartyGSTIN = "";
    let Customer = "";
    let CustomerName = "";
    let CustomerGSTIN = "";
    let PartyAddress = "";
    let CustomerAddress = "";
    let PartyFSSAINo = "";
    let CustomerFSSAINo = "";
    let CustomerState = "";
    let PartyState = "";
    let PartyMobileNo = "";
    let CustomerMobileNo = "";


    if (grn.GRNReferences?.[0]?.Order) {   // GRN From vendor order If Not null
        Party = order.Supplier?.id || null;
        PartyName = order.Supplier?.Name || "";
        PartyGSTIN = order.Supplier?.GSTIN || "";
        Customer = order.Customer?.id || null;
        CustomerName = order.Customer?.Name || "";
        CustomerGSTIN = order.Customer?.GSTIN || "";

        PartyAddress = grn.PartyAddress || "";
        CustomerAddress = billingAddress.Address || grn.CustomerAddress || "";
        PartyFSSAINo = grn.PartyFSSAINo || "";
        CustomerFSSAINo = billingAddress.FSSAINo || grn.CustomerFSSAINo || "";
        PartyState = grn.PartyState || "";
        CustomerState = grn.CustomerState || "";
        PartyMobileNo = grn.PartyMobileNo || "";
        CustomerMobileNo = grn.CustomerMobileNo || "";
    } else {
        Party = grn.Party || null;
        PartyName = grn.PartyName || "";
        PartyGSTIN = grn.PartyGSTIN || "";
        PartyAddress = grn.PartyAddress || "";
        PartyFSSAINo = grn.PartyFSSAINo || "";
        PartyState = grn.PartyState || "";
        PartyMobileNo = grn.PartyMobileNo || "";

        Customer = grn.Customer || null;
        CustomerName = grn.CustomerName || "";
        CustomerGSTIN = grn.CustomerGSTIN || "";
        CustomerAddress = grn.CustomerAddress || "";
        CustomerFSSAINo = grn.CustomerFSSAINo || "";
        CustomerState = grn.CustomerState || "";
        CustomerMobileNo = grn.CustomerMobileNo || "";
    }



    const transformedData = {
        StatusCode: 200,
        Status: true,
        Data: {
            id: grn.id,
            InvoiceDate: grn.GRNDate,
            InvoiceNumber: grn.GRNNumber,
            FullInvoiceNumber: grn.FullGRNNumber,
            TCSAmount: "0.00",
            GrandTotal: grn.GrandTotal,
            RoundOffAmount: grn.RoundOffAmount,
            Customer: Customer,
            CustomerName: CustomerName,
            CustomerGSTIN: CustomerGSTIN,
            CustomerMobileNo: CustomerMobileNo,
            Party: Party,
            PartyName: PartyName,
            PartyGSTIN: PartyGSTIN,
            PartyMobileNo: PartyMobileNo,
            PartyFSSAINo: PartyFSSAINo,
            CustomerFSSAINo: CustomerFSSAINo,
            PartyState: PartyState,
            CustomerState: CustomerState,
            PartyAddress: PartyAddress,
            CustomerAddress: CustomerAddress,

            DriverName: null,
            VehicleNo: null,
            CreatedOn: grn.GRNDate,

            InvoiceItems: grn.GRNItems.map((item, index) => ({
                Item: item.Item,
                ItemName: item.ItemName,
                Quantity: item.Quantity,
                TrayQuantity: item.BaseUnitQuantity,
                MRP: item.MRP,
                MRPValue: item.MRPValue,
                Rate: item.Rate,
                TaxType: item.TaxType,
                PrimaryUnitName: item.UnitName,
                UnitName: item.UnitName,
                BaseUnitQuantity: item.BaseUnitQuantity,
                GST: item.GST,
                GSTPercentage: item.GSTPercentage,
                MarginValue: null,
                BasicAmount: item.BasicAmount,
                GSTAmount: item.GSTAmount,
                CGST: item.CGST,
                SGST: item.SGST,
                IGST: item.IGST,
                CGSTPercentage: item.CGSTPercentage,
                SGSTPercentage: item.SGSTPercentage,
                IGSTPercentage: item.IGSTPercentage,
                Amount: item.Amount,
                BatchCode: item.BatchCode,
                BatchDate: item.BatchDate,
                ItemExpiryDate: item.ItemExpiryDate,
                HSNCode: item.HSNCode,
                DiscountType: item.DiscountType,
                Discount: item.Discount,
                DiscountAmount: item.DiscountAmount,
                Comment: order?.OrderItem?.[index]?.Comment || "",
            })),

            InvoicesReferences: [{
                Order: order.id,
                FullOrderNumber: order.FullOrderNumber,
                Description: order.Description || ""
            }],

            InvoiceUploads: [],
            BankData: [],
            ReportFormat: "GRN"
        }
    };

    return transformedData;
}



